// import {fetchUsers} from '@/devicehq/api/users'
import {DEVICEHQ} from '@/devicehq/api'

const getUsers = context => {
  // fetchUsers
  DEVICEHQ.get('/api/v2/account/users', {
    data: {},
  })
    .then(response => {
      context.commit('USERS_UPDATED', response.data)
    })
    .catch(error => {
      // eslint-disable-next-line
    console.error(error)
    })
}

export default {
  getUsers,
}



// WEBPACK FOOTER //
// ./src/devicehq/store/modules/users/actions.js